import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from "moment";

import { currentLanguage } from 'helpers';

import Glider from 'partials/Glider/Glider';
import tagObjectArray from 'partials/Glider/Filters/SwitchTags';

export class AdventureGliderList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tags: []
        };
    }

    componentDidMount() {
        this.filterByMonth();
    }

    componentDidUpdate(prevProps) {
        let { adventures, initiateAdventureFiltering } = this.props;
        if(prevProps.adventures !== adventures || prevProps.initiateAdventureFiltering !== initiateAdventureFiltering) {
            this.filterByMonth();
        }
    }

    filterByMonth = () => {
        let arrivalDate = moment(this.props.fromDate, 'YYYY/MM/DD').format('YYYY-MM-DD');
        let arr = [];
        this.props.adventures.map(adventure => {
           let fromDate = moment(adventure.acf.from_date,'MM/DD/YYYY').format('YYYY-MM-DD');
           let toDate = moment(adventure.acf.to_date,'MM/DD/YYYY').format('YYYY-MM-DD');
           if(moment(arrivalDate).isBetween(fromDate,toDate)) {
               arr.push(adventure);
           }
           return null;
        });
        this.getTags(arr);
    }

    getTags = adventures => {
        let caseArr = [];
        let tagArr = [];

        adventures.map(item => {
            item.acf.tags.map(tag => {
                if(!caseArr.includes(tag) && tagObjectArray.filter(item => item.value === tag).length > 0) {
                    tagArr.push(tagObjectArray.filter(item => item.value === tag)[0]);
                    caseArr.push(tag);
                }
                return null;
            })
            return null;
        })
        
        let flatArr = tagArr.flat();
        flatArr.map(tag => {
            this.setState({[tag.value]: []});
            return null;
        })
        
        this.setState({tags: flatArr},() => this.filterByTags(adventures));
    }

    filterByTags = adventures => {
        this.state.tags.map(tag => {
            adventures.map(item => {
                if(item.acf.tags.includes(tag.value)) {
                    let arr = this.state[tag.value];
                    arr.push(item);
                    this.setState({[tag.value]: arr})
                }
                return null;
            })
            return null;
        })
        this.props.sendAdventureCount(adventures.length);
    }
    
    render() {
        const { tags } = this.state;
        
        return (
            <div id="activities">
                { tags.map((tag, idx) => {
                    let value = this.state[tag.value].length ? this.state[tag.value] : null;
                    if(!value) return <div />;
                    return (
                        <Glider 
                            data={value}
                            title={currentLanguage() === 'no' ? tag.title.no : tag.title.en}
                            key={idx}
                        />
                    )}
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    fromDate: state.availability.fromDate
})

export default connect(mapStateToProps, null)(AdventureGliderList);